import { ColumnHelper } from "@tanstack/react-table";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { useCallback } from "react";

import { ActionsCell } from "./actions_cell";
import css from "./actions_cell.module.scss";

type UseActionsColumnProps = {
  roleFormKeys: RoleFormKey[];
  onChange: (roleFormKey: RoleFormKey, action: ActionType) => void;
  actionsBlacklist?: ActionType[];
  disableIfRoleExists?: boolean;
};

export enum ActionType {
  BulkAddHours = "bulk_add_hours",
  Remove = "remove",
  MarkForRemoval = "mark_for_removal",
  UndoMarkForRemoval = "undo_mark_for_removal",
  Duplicate = "duplicate",
  EditAvailability = "edit_availability"
}

export const useActionsColumn = <DATA extends object>({
  roleFormKeys,
  onChange,
  actionsBlacklist,
  disableIfRoleExists
}: UseActionsColumnProps) => {
  const generateColumn = useCallback(
    (columnHelper: ColumnHelper<DATA>) =>
      columnHelper.accessor((row) => row, {
        id: "actions",
        header: "",
        cell: (info) => (
          <ActionsCell
            roleFormKey={roleFormKeys[info.row.index]}
            onChange={onChange}
            actionsBlacklist={actionsBlacklist}
            disableIfRoleExists={disableIfRoleExists}
          />
        ),
        size: 32,
        enableSorting: false,
        meta: {
          sticky: true,
          cellClassName: css.actionsCell
        }
      }),
    [onChange, actionsBlacklist, roleFormKeys, disableIfRoleExists]
  );
  return generateColumn;
};
